import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

export interface Video {
  id?: number;
  vimeoUri?: string;
  userId?: number;
  created?: string;
}

const URL = '/v2/videos';

class VideoService {
  static getByFilter(config: AxiosRequestConfig) {
    return axios.get(URL, config);
  }

  static create(
    data: { vimeoUri: string; userId: number },
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Video>> {
    return axios.post(URL, data, config);
  }
}

export { VideoService };
